export default __webpack_public_path__ + "static/media/PhoneScreen@2x.7c47d1ea.jpeg";